// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__Il0NH","content":"Link_content__erxWv"};